// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { BackOrdersDataViewContext } from "@store/Framework/Store/Store/Data/BackOrders/BackOrdersSelectors";
import updateSearchFields from "@store/Framework/Store/Store/Pages/BackOrders/Handlers/UpdateSearchFields";
import { Pagination, PaginationPresentationProps } from "@store/MobiusOverrides/Pagination";
import { ThemeProps, withTheme } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ThemeProps<BaseTheme> & ResolveThunks<typeof mapDispatchToProps>;

export interface BackOrdersPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const backOrdersPaginationStyles: BackOrdersPaginationStyles = {};

const styles = backOrdersPaginationStyles;

const BackOrdersPagination = ({ updateSearchFields, theme }: Props) => {
    const backOrdersDataView = usePersistentDataView(useContext(BackOrdersDataViewContext));
    const pagination =
        backOrdersDataView.value && backOrdersDataView.pagination ? backOrdersDataView.pagination : undefined;

    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    const pageSizeCookieName = "BackOrders-PageSize";

    return (
        <Pagination
            {...styles.pagination}
            theme={theme}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie={pageSizeCookieName}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
            hidePerPageSelect={false}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(withTheme(BackOrdersPagination)),
    definition: {
        displayName: "Pagination",
        group: "Order History",
        allowedContexts: ["BackOrdersPage"],
    },
};

export default widgetModule;
